import './AccountsPage.css';
import React, { useState, useEffect, useRef } from "react";
import { IonContent, IonList, IonIcon, IonPage, IonThumbnail, IonItem, IonLabel, IonCard, IonRefresher, IonCardContent, IonHeader, IonSkeletonText, IonAvatar, IonListHeader, IonText, IonSegment, IonSegmentButton, RefresherEventDetail, useIonLoading, IonToolbar, IonButtons, useIonModal, useIonAlert, IonButton, IonModal, IonRow, useIonViewDidEnter } from '@ionic/react';
import BalanceCard from '@/components/accounts/BalanceCard';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '../../services/redux/hook';
import supportedCurrencies from '../../currencies.json';
import { Asset, CoinGeckoSimplePriceParams, DestinationUserName, PaymentDestinationInfo, Sep10ChallengeParams, WalletInfoState } from "../../types/types";
import { stellarApi, useAccountDetailsQuery } from "../../services/api/stellar";
import { ebioroApi, useGetQuotesQuery, useGetUserInfoQuery, UserFedrationParams } from "../../services/api/ebioro/ebioro";
import { setSelectedAsset } from "../../services/redux/slices/selected-asset/selected-asset";

import { useGetSimplePriceQuery } from "../../services/api/coin-gecko/coingecko";
import { setQuotes } from "../../services/redux/slices/quotes/quotes";
import { setUser } from "../../services/redux/slices/user/user";
import { Networks } from "@stellar/stellar-sdk";
import { receivedSep10Token } from "../../services/redux/slices/auth/sep10";
import { AdvertisingId } from '@capacitor-community/advertising-id';
import TagManager from 'react-gtm-module';
import packageInfo from "../../../package.json";
import { Capacitor } from "@capacitor/core";
import BaseModalComponent from "../../components/BaseModalComponent/BaseModalComponent";
import Profile from "../profile/Profile";
import { IconContext } from 'react-icons';
import { RiUserSettingsLine } from "react-icons/ri";
import { RiMoonLine, RiSunLine } from 'react-icons/ri';
import AccountDetailsPage from "../accounts-details/AccountDetailsPage";
import { PayStellarUri } from "../../services/stellar/stellar-uri/pay-stellar-uri";
import { isStellarAccount } from "../../services/stellar/stellar-utils";
import AmountPage from "../amount/AmountPage";
import SendPage from "../send/SendPage";
import { resetPaymentDestinationInfo, setPaymentDestinationInfo } from "../../services/redux/slices/paymentDestinationInfo/paymentDestinationInfo";
import { isStellarUri, parseStellarUri } from "../../services/stellar/stellar-uri/parse";
import { setOpenedSep7Uri } from "../../services/redux/slices/opened_sep7_scheme/opened_stellar_uri_scheme";
import DisbursementPage from "../disbursement/DisbursementPage";

import * as Sentry from '@sentry/react';
import { openModal } from "../../services/redux/slices/opened_navigation_modal/opened_root_modal";
import useCryptoMode from '../../hooks/useCryptoMode';
import AddAccountPage from '../add-account/AddAccountPage';
import * as BarcodeScanner from '@capacitor/barcode-scanner';
import { RiQrScanLine } from "react-icons/ri";
import * as walletSdk from '@stellar/typescript-wallet-sdk';
import AddSignerModal from '../../components/AddSignerModal/AddSignerModal';
import QuickActions from '@/components/accounts/QuickActions';
import AccountSummary from '@/components/accounts/AccountSummary';

import { useHistory } from 'react-router-dom';
import useDarkMode from '@/hooks/useDarkMode';
import RecipientPage from '../recipients/RecipientPage';
import ReceivePage from '../receive/ReceivePage';
import GeneratePdf from '../pdf/GeneratePdf';
import CashAccountPage from './CashAccountPage';
import CryptoAccountPage from './CryptoAccountPage';
import TradePage from '../trade/TradePage';

const ebioroAuthDomain = import.meta.env.VITE_API_AUTH_DOMAIN || '';
const isTestnet = import.meta.env.VITE_isTestnet === 'true' ? true : false;
const environment = import.meta.env.VITE_ENVIRONMENT;
const gtmId = import.meta.env.VITE_GTM_ID;


const AccountsPage: React.FC<any> = () => {

    const pageRef = useRef(null);
    const history = useHistory();
    const [presentingElement, setPresentingElement] = useState<HTMLElement | null>(null);

    const [refreshCounter, setRefreshCounter] = useState(0);
    const { cryptoMode } = useCryptoMode();
    const { darkMode, toggleDarkMode } = useDarkMode();


    const dispatch = useAppDispatch();
    const { t, i18n } = useTranslation();
    const walletInfo: WalletInfoState = useAppSelector((state) => state.walletInfo);
    const supportedAssets: Asset[] = useAppSelector((state) => state.supportedAssets.supportedAssets);
    const ebioroAuthToken = useAppSelector((state) => state.sep10AuthToken.tokens[ebioroAuthDomain]);

    const [present, dismiss] = useIonLoading();
    const [showProfileModal, dismissProfileModal] = useIonModal(BaseModalComponent, { component: Profile });
    const [showDisbursementPage, dismissDisbursementPage] = useIonModal(BaseModalComponent, { component: DisbursementPage });

    const [showDetailsPage, dismissDetailsPage] = useIonModal(BaseModalComponent, { component: AccountDetailsPage });

    const [showAmountPage, dismissAmountPage] = useIonModal(BaseModalComponent, { component: AmountPage });


    const [showSendPage, dismissSendPage] = useIonModal(BaseModalComponent, { component: SendPage });
    const [showAddAccountPage, dismissAddAccountPage] = useIonModal(BaseModalComponent, { component: AddAccountPage });

    const [showRecipientPage, dismissRecipientPage] = useIonModal(BaseModalComponent, { component: RecipientPage });

    const [showReceivePage, dismissReceivePage] = useIonModal(BaseModalComponent, { component: ReceivePage });

    const [showStatementPage, dismissStatementPage] = useIonModal(BaseModalComponent, { component: GeneratePdf });

    const [showTradePage, dismissTradePage] = useIonModal(BaseModalComponent, { component: TradePage });

    const [addAccountIsOpen, setAddAccountIsOpen] = useState(false);
    const [showAddAccount, setShowAddAccount] = useState(false);
    const addAcountModal = useRef<HTMLIonModalElement>(null);


    const { data: accountDetails, isLoading: isAccountLoading, isError: isAccountError, error: accountError } = useAccountDetailsQuery(walletInfo.account_key, { skip: (!walletInfo.has_key) });

    let balances: any;

    const tagManagerArgs = {
        gtmId: gtmId as string,
        dataLayer: {
            ebioroapp: {
                env: environment,
                appversion: packageInfo.version
            }

        },

    }

    if (accountDetails && accountDetails.details.id) {

        balances = accountDetails.details.balances;
    }

    let coins = '';
    let coinGeckoCoins = '';
    let coingeckoCurrencies = ''

    supportedAssets.map((asset: any) => {

        if (!coins || coins === '') {
            coins = asset.code
            coinGeckoCoins = asset.coingecko_id;

        }
        else {
            coins = coins + ',' + asset.code;
            coinGeckoCoins = coinGeckoCoins + ',' + asset.coingecko_id;
        }

    })

    supportedCurrencies.map((currency) => {

        if (!coingeckoCurrencies || coingeckoCurrencies === '') {
            coingeckoCurrencies = currency.code.toLocaleLowerCase();

        }
        else {
            coingeckoCurrencies = coingeckoCurrencies + ',' + currency.code.toLocaleLowerCase();
        }

    })

    const simplePricingParams: CoinGeckoSimplePriceParams = {

        ids: coinGeckoCoins,
        vs_currencies: coingeckoCurrencies,
        include_market_cap: true,
        include_24hr_vol: true,
        include_24hr_change: true,
        include_last_updated_at: true


    }

    const { data: quotes = [], isSuccess: quotesIsSuccess, isLoading: isQuotesLoading, isError: isQuotesError, refetch } = useGetQuotesQuery(
        { coins: coins, authToken: ebioroAuthToken },
        { skip: ebioroAuthToken === '' || ebioroAuthToken === undefined, refetchOnMountOrArgChange: true });
    const [isFetchingQuotes, setIsFetchingQuotes] = useState(true);
    const { data: userInfo, isSuccess: userInfoSuccess, isLoading: isUserLoading, isError: isUserError } = useGetUserInfoQuery(ebioroAuthToken, { skip: (ebioroAuthToken === '' || ebioroAuthToken === undefined) });
    const { data: coinGeckoQuotes } = useGetSimplePriceQuery(simplePricingParams, {})

    const openedSep7Uri: string = useAppSelector((state) => state.openedSep7Uri);
    const openedDisbursementUri: string = useAppSelector((state) => state.openedDisbursementUri);
    const selectedTab: string = useAppSelector((state) => state.selectedTab);

    const [presentAlert] = useIonAlert();
    const asset: Asset = useAppSelector((state) => state.selectedAsset); // initial asset default is XLM

    const presentErrorAlert = (error: string, title?: string) => {
        presentAlert({
            header: title ? title : "Error",
            message: `${error}`,
            buttons: [
                {
                    text: "Close",
                    role: "cancel",
                    handler: () => {
                        dismiss();
                        return;
                    },
                },
            ],
        });
    };

    // Memoized filtered assets to avoid recalculating filter on every render
    const filteredAssets = React.useMemo(() => {
        return supportedAssets.filter((asset: Asset) => {
            // Always show fiat assets, and only show crypto assets when cryptoMode is enabled
            return asset.type === 'fiat' || (cryptoMode && asset.type === 'crypto');
        });
    }, [supportedAssets, cryptoMode]);

    const setInitialAsset = React.useCallback(() => {
        const usdcAsset = supportedAssets.find((asset: Asset) =>
            asset.identifier.startsWith('USDC')
        );

        if (usdcAsset) {
            dispatch(setSelectedAsset(usdcAsset));
        }
    }, [supportedAssets, dispatch]);

    const goToReviewPage = async () => {

        dispatch(setOpenedSep7Uri('')); // setting the uri back to empty string.
        dispatch(openModal({ dismissFunc: dismissSendPage }));

        setTimeout(() => {
            showSendPage({
                // presentingElement: presentingElement!,
            });
        }, 200);
    }


    const presentProfileModal = async () => {
        dispatch(openModal({ dismissFunc: dismissProfileModal }));

        setTimeout(() => {

            showProfileModal({
                //presentingElement: presentingElement!
            })

        }, 100)



    }

    const goToAmountPage = () => {

        dispatch(setOpenedSep7Uri('')); // setting the uri back to empty string.
        dispatch(openModal({ dismissFunc: dismissAmountPage }));

        setTimeout(() => {
            showAmountPage({
                //presentingElement: presentingElement!,
            });
        }, 100);


    }


    const gotoDisbursementPage = () => {

        dispatch(openModal({ dismissFunc: dismissDisbursementPage }));

        setTimeout(() => {
            showDisbursementPage({
                //presentingElement: presentingElement!,
            });
        }, 100);

    }

    const goToAddAccountPage = async (asset: Asset) => {
        dispatch(setSelectedAsset(asset));
        await addAcountModal.current?.dismiss();
        dispatch(openModal({ dismissFunc: dismissAddAccountPage }));

        setTimeout(() => {
            showAddAccountPage({});
        }, 100);
    }

    const addAccountSigner = async () => {
        if (!userInfo?.email) {
            presentErrorAlert(
                t('accounts.add-signer.NO_EMAIL_ERROR') as string,
                t('Error') as string
            );
            return;
        }

        // Show the modal to explain why we're adding a signer
        dispatch(openModal({ dismissFunc: dismissAddSignerPage }));

        setTimeout(() => {
            showAddSignerPage({})
        }, 100);
    };

    const handleAddSignerCancel = () => {
        dismissAddSignerPage();
    };

    // Handle quotes validation and refetching
    useEffect(() => {
        if (quotesIsSuccess && quotes) {
            const hasNullQuotes = Object.values(quotes).some(value => value === null);

            if (hasNullQuotes) {
                refetch();
            } else {
                setIsFetchingQuotes(false);
            }
        }
    }, [quotes, quotesIsSuccess, refetch]);

    // Handle redirect if no wallet account key
    useEffect(() => {
        if (!walletInfo?.account_key) {
            history.replace("/");
        }
    }, [walletInfo?.account_key, history]);

    // Set presenting element (only once)
    useEffect(() => {
        setPresentingElement(pageRef.current);
    }, []);

    // Handle CoinGecko quotes
    useEffect(() => {
        if (coinGeckoQuotes) {
            dispatch(setQuotes(coinGeckoQuotes));
        }
    }, [coinGeckoQuotes, dispatch]);

    // Handle user info
    useEffect(() => {
        if (userInfo?.id) {
            dispatch(setUser(userInfo));
        }
    }, [userInfo?.id, dispatch]);

    // Handle account details and initial asset setup
    useEffect(() => {
        if (accountDetails?.details?.id) {
            setInitialAsset();

            if (accountDetails?.details?.signers && accountDetails.details.signers.length < 3) {
                addAccountSigner();
            }
        }
    }, [accountDetails?.details?.id, accountDetails?.details?.signers?.length, setInitialAsset]);

    // Memoized calculation for missing balances
    const hasMissingBalances = React.useMemo(() => {
        if (!accountDetails?.details) return false;
        return supportedAssets.some(asset =>
            !accountDetails?.details?.balances?.[asset.identifier]
        );
    }, [supportedAssets, accountDetails?.details]);

    // Handle missing balances check
    useEffect(() => {
        setShowAddAccount(hasMissingBalances);
    }, [hasMissingBalances]);

    // Handle Sep10 authentication token
    useEffect(() => {
        const initSep10Auth = async () => {
            if (!ebioroAuthToken && walletInfo.account_key && walletInfo.device_private_key) {
                const params: Sep10ChallengeParams = {
                    account: walletInfo.account_key,
                    home_domain: ebioroAuthDomain,
                    network: isTestnet ? Networks.TESTNET : Networks.PUBLIC,
                    privateKey: walletInfo.device_private_key
                };

                try {
                    const data = await dispatch(stellarApi.endpoints.sep10.initiate(params)).unwrap();
                    if (data) {
                        dispatch(receivedSep10Token(data));
                    }
                } catch (error) {
                    console.error('Sep10 authentication failed:', error);
                }
            }
        };

        initSep10Auth();
    }, [ebioroAuthToken, walletInfo.account_key, walletInfo.device_private_key, dispatch]);

    // Set up tracking permissions (only once)
    useEffect(() => {
        if (Capacitor.getPlatform() !== 'web') {
            setUpTrackingPermission();
        }
    }, []);

    // Handle Sep7 URI opening
    useEffect(() => {
        if (openedSep7Uri && selectedTab === 'accounts') {
            handleSep7OpenUri();
        }
    }, [openedSep7Uri, selectedTab]);

    // Handle disbursement URI opening  
    useEffect(() => {
        if (openedDisbursementUri && selectedTab === 'accounts') {
            handleOpenedDisbursementUri();
        }
    }, [openedDisbursementUri, selectedTab]);

    // Set Sentry context when user info is available
    useEffect(() => {
        if (userInfo?.id) {
            setSentryContext();
        }
    }, [userInfo?.id]);


    const sleep = (ms: number) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function doRefresh(event: CustomEvent<RefresherEventDetail>) {

        present();

        await sleep(1200);

        const updatedCounter = refreshCounter + 1;

        setRefreshCounter(updatedCounter)

        event.detail.complete();
        dismiss()

    }

    const setUpTrackingPermission = async () => {

        try {

            const adStatus = await AdvertisingId.getAdvertisingStatus();

            if (adStatus.status === 'Authorized') {

                TagManager.initialize(tagManagerArgs);
            }

            else {

                const response = await AdvertisingId.requestTracking();

                if (response.value === 'Authorized') {
                    TagManager.initialize(tagManagerArgs);
                }
            }

        } catch (error) {

            Sentry.captureException(error);

        }
    }


    const handleSep7OpenUri = async () => {

        try {

            const uriResult = walletSdk.parseSep7Uri(openedSep7Uri);

            if (!(uriResult instanceof walletSdk.Sep7Pay)) {
                presentErrorAlert(`This link is not supported.`);
                return;
            }

            const passesVerification = await uriResult.verifySignature();

            if (!passesVerification) {

                presentErrorAlert(`This link is not supported.`);
                return;

            }

            else {
                validatepaymentLinkOrQrContent(openedSep7Uri);
            }

        } catch (error) {

        }

        //validatepaymentLinkOrQrContent(openedSep7Uri);

    }

    const handleOpenedDisbursementUri = async () => {

        gotoDisbursementPage();

    }


    const validatepaymentLinkOrQrContent = async (content: string): Promise<React.FC<{}> | undefined> => {

        if (isStellarAccount(content)) {

            const response = await validatePaymentLink(content);

            if (response) {

                dispatch(resetPaymentDestinationInfo());

                const destinationInfo: PaymentDestinationInfo = {
                    destination_address: content,
                    destination_asset: undefined,
                    destination_amount: undefined,
                }

                dispatch(setPaymentDestinationInfo(destinationInfo));

                // Navigate immediately without setTimeout delay
                goToAmountPage();
                return;
            }
        }

        if (isStellarUri(content)) {

            const uri = parseStellarUri(content);

            if (uri instanceof PayStellarUri) {

                if (!uri.destination) {
                    const error = t("accounts.payment.link.NO-DESTINATION-ACCOUNT");
                    presentErrorAlert(error);
                    return undefined;
                }

                const response = await validatePaymentLink(uri);

                if (response) {

                    let destinationAsset = asset;

                    // Optimize asset lookup using find() instead of for loop
                    if (uri.assetCode && uri.assetIssuer) {
                        const foundAsset = supportedAssets.find(asset =>
                            asset.identifier === `${uri.assetCode}:${uri.assetIssuer}`
                        );
                        if (foundAsset) {
                            destinationAsset = foundAsset;
                        }
                    } else if (!uri.assetCode) {
                        // Optimize native asset lookup
                        const nativeAsset = supportedAssets.find(asset => asset.identifier === 'native');
                        if (nativeAsset) {
                            destinationAsset = nativeAsset;
                        }
                    }

                    const destinationInfo: PaymentDestinationInfo = {
                        destination_address: uri.destination,
                        destination_asset: destinationAsset,
                        destination_amount: uri.amount ? parseFloat(uri.amount).toFixed(2) : undefined,
                        destination_memo: uri.memo ? uri.memo : undefined,
                        destination_memo_type: uri.memo ? 'text' : undefined,
                        message: uri.msg ? decodeURI(uri.msg) : undefined
                    }

                    if (uri.name) {
                        let destination_username: DestinationUserName = {
                            name: decodeURI(uri.name),
                            username: t('barcode.page.merchant-place-holder') as string
                        }
                        destinationInfo.destination_username = destination_username
                    }

                    // Set payment info and asset first for immediate UI update
                    dispatch(setPaymentDestinationInfo(destinationInfo));
                    dispatch(setSelectedAsset(destinationAsset));

                    // Navigate immediately based on amount presence
                    if (!uri.amount) {
                        goToAmountPage();
                    } else {
                        goToReviewPage();
                    }

                    // Do federation lookup in background (non-blocking)
                    if (!uri.name) {
                        const params: UserFedrationParams = {
                            q: uri.destination,
                            type: 'id'
                        }

                        // Fire and forget - don't await this
                        dispatch(ebioroApi.endpoints.userFederation.initiate(params))
                            .unwrap()
                            .then(response => {
                                if (response.user_name) {
                                    const destination_username: DestinationUserName = {
                                        name: response.user_name
                                    }
                                    // Update the already dispatched payment info with username
                                    dispatch(setPaymentDestinationInfo({
                                        ...destinationInfo,
                                        destination_username
                                    }));
                                }
                            })
                            .catch(() => {
                                // Silent fail - don't do anything if error
                            });
                    }

                    return;
                }

            } else {
                const error = t("accounts.payment.link.NO-SUPPORTED-TX-URI");
                presentErrorAlert(error);
                return undefined;
            }
        } else {
            const error = t("accounts.payment.link.NO-SUPPORTED-TX-URI");
            presentErrorAlert(error);
            return undefined;
        }

    }

    const validatePaymentLink = async (value: PayStellarUri | string): Promise<boolean> => {

        if (!value) {
            const error = t("accounts.payment.link.unsupported");
            presentErrorAlert(error);
            return false;
        }

        let destination: string;

        if (value instanceof PayStellarUri) {
            destination = value.destination.toString();
        }

        else {
            destination = value;
        }

        const isAccount = isStellarAccount(destination);


        if (!isAccount) {
            const error = t("accounts.payment.link.NO-DESTINATION-ACCOUNT");
            presentErrorAlert(error);
            return false;
        }

        if (isAccount && walletInfo.account_key === destination) {

            const error = t("accounts.payment.link.invalid.SAME-RECIPIENT-ERROR");
            presentErrorAlert(error);
            return false;
        }


        else {

            return true;

        }

    };

    const onQuickSend = () => {
        dispatch(resetPaymentDestinationInfo());
        dispatch(openModal({ dismissFunc: dismissRecipientPage }));

        setTimeout(() => {
            showRecipientPage({});
        }, 200);
    }

    const onQuickReceive = async () => {
        dispatch(openModal({ dismissFunc: dismissReceivePage }));
        setTimeout(() => {
            showReceivePage({
            });
        }, 200);
    }

    const onStatement = async () => {
        dispatch(openModal({ dismissFunc: dismissStatementPage }));
        setTimeout(() => {
            showStatementPage({
            });
        }, 200);
    }

    const onTrade = () => { 
        dispatch(openModal({ dismissFunc: dismissTradePage }));
        setTimeout(() => {
            showTradePage({
            });
        }, 200);
    }

    const onCashAccountClick = async () => {
        dispatch(openModal({ dismissFunc: dismissCashAccountPage }));
        setTimeout(() => {
            showCashAccountPage({});
        }, 200);
    }

    const onCryptoAccountClick = async () => {
        dispatch(openModal({ dismissFunc: dismissCryptoAccountPage }));
        setTimeout(() => {
            showCryptoAccountPage({});
        }, 200);
    }

    const setSentryContext = () => {

        if (userInfo) {

            Sentry.setUser({
                id: userInfo.id,
                email: userInfo.email
            });
        }

    }

    const handleOpenCamera = async (val?: number) => {

        const options: BarcodeScanner.CapacitorBarcodeScannerOptions = {
            hint: val || 17,
            scanButton: false,
            cameraDirection: BarcodeScanner.CapacitorBarcodeScannerCameraDirection.BACK
        }

        try {

            const result = await BarcodeScanner.CapacitorBarcodeScanner.scanBarcode(options);
            validatepaymentLinkOrQrContent(result.ScanResult)

        } catch (error) {


        }

    }

    const AddSignerModalWithProps: React.FC = () => (
        <AddSignerModal
            onCancel={handleAddSignerCancel}
            closeModal={dismissAddSignerPage}
        />
    );

    // Define the modal hooks after the wrapper components
    const [showCashAccountPage, dismissCashAccountPage] = useIonModal(BaseModalComponent, { component: CashAccountPage });
    const [showCryptoAccountPage, dismissCryptoAccountPage] = useIonModal(BaseModalComponent, { component: CryptoAccountPage });
    const [showAddSignerPage, dismissAddSignerPage] = useIonModal(BaseModalComponent, { component: AddSignerModalWithProps });


    {
        return (

            <IonPage ref={pageRef}>

                <IonHeader className="ion-no-border">
                    <IonToolbar >
                        <IonButtons slot="start">
                            <IonButton color={'primary'} onClick={() => toggleDarkMode()}>
                                <IconContext.Provider value={{ size: "28px" }}>
                                    {darkMode ? <RiSunLine /> : <RiMoonLine />}
                                </IconContext.Provider>
                            </IonButton>
                        </IonButtons>
                        <IonButtons slot="end">
                            <IonButton color={'primary'} onClick={() => presentProfileModal()}>
                                <IconContext.Provider value={{ size: "28px" }}>
                                    <RiUserSettingsLine />
                                </IconContext.Provider>
                            </IonButton>
                        </IonButtons>
                        <IonButtons slot="primary">
                            <IonButton color={'primary'} onClick={() => handleOpenCamera()}>
                                <IconContext.Provider value={{ size: "28px" }}>
                                    <RiQrScanLine />
                                </IconContext.Provider>
                            </IonButton>
                        </IonButtons>

                    </IonToolbar>

                </IonHeader>

                <IonContent className="ion-no-padding" scrollY={false}>


                    <IonRefresher slot="fixed" onIonRefresh={doRefresh}></IonRefresher>
                    {
                        /** MODAL TO CREATE ACCOUNT */

                        <IonModal
                            ref={addAcountModal}
                            isOpen={addAccountIsOpen}
                            onDidDismiss={() => setAddAccountIsOpen(false)}
                            initialBreakpoint={0.25}
                            breakpoints={[0, 0.25, 0.5, 0.75]}>
                            <IonContent className="ion-padding">
                                <IonCard>
                                    <IonCardContent>
                                        <IonList lines='none' className="bg-transparent">

                                            {
                                                filteredAssets
                                                    .map((asset: Asset) => {

                                                        {
                                                            return (
                                                                !accountDetails?.details.balances[asset.identifier] && (


                                                                    <IonItem lines="none" key={asset.identifier}>

                                                                        <IonThumbnail className="w-9 h-9" slot="start">
                                                                            <img src={asset.icon} />
                                                                        </IonThumbnail>

                                                                        <IonLabel className="font-medium text-xl w-[90%]">
                                                                            <h4>
                                                                                {asset.code}
                                                                            </h4>

                                                                        </IonLabel>
                                                                        <IonButton
                                                                            onClick={() => { goToAddAccountPage(asset) }}
                                                                            color={'primary'}
                                                                            fill='outline'
                                                                            slot='end'> {t('accounts.btn.ADD_ACCOUNT_MODAL')}

                                                                        </IonButton>
                                                                    </IonItem>

                                                                )
                                                            )
                                                        }


                                                    })
                                            }
                                        </IonList>
                                    </IonCardContent>
                                </IonCard>

                            </IonContent>
                        </IonModal>
                    }

                    <div>

                        <BalanceCard
                            style={{
                                margin: '16px',
                                minHeight: '200px' // This makes it 30% taller than the default
                            }}
                        />

                        <QuickActions
                            onSend={() => onQuickSend()}
                            onReceive={() => onQuickReceive()}
                            onStatement={() => onStatement()}
                            onTrade={() => onTrade()}

                            style={{ marginTop: '30px' }}
                        />

                        <AccountSummary
                            style={{ margin: '16px 0 30px 0' }}
                            onCashClick={onCashAccountClick}
                            onCryptoClick={onCryptoAccountClick}
                        />

                    </div>


                </IonContent>

            </IonPage>
        )
    }
}

export default React.memo(AccountsPage)

